export default __webpack_public_path__ + "static/media/phantom-dai-opera.b9bce777.png";